import { queryOptions } from '@tanstack/react-query';

import { getRecruitingAllQuery, getRecruitingQuery } from './shared';

export const getRecruitingQueryOptions = (id: string) => queryOptions(getRecruitingQuery(id));
export const getRecruitingAllQueryOptions = () => queryOptions(getRecruitingAllQuery());
